import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        position: 'relative' as const,
        flexGrow: 1
    },
    walletContainer: {
        height: '25%',
        minHeight: '165px',
        backgroundColor: '#FFFFFF',
        padding: '1rem 2.5rem',
        marginTop: '1rem'
    },
    backButton: {
        position: 'absolute' as const,
        top: '-.75rem',
        left: '1rem'
    },
    accountAdditionalInfoContainer: {
        flexGrow: 1,
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#F1F2F2',
        padding: '1.5rem 24px',
        marginTop: '-1rem'
    },
    accountStatisticsPanel: {
        width: 'auto' as const,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2.5rem',
        marginTop: '1rem'
    },
    accountTransactionHistoryPanel: {
        height: 'fit-content' as const,
        flexBasis: 'auto' as const,
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1.5rem',
        marginTop: '1rem'
    },
    accountUsersPanel: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary || '#FFFFFF',
        padding: '1rem 2.5rem',
        marginTop: '1rem',
        minWidth: '592px'
    },
    panelHeader: {
        color: theme?.app?.applicationColors.enumColors.black || '#000000',
        fontSize: '.8rem',
        textTransform: 'uppercase' as const,
        alignSelf: 'flex-start' as const
    },
    statisticWithLabel: { paddingTop: '2.5rem' },
    statisticWithLabelSmallPadding: { paddingTop: '1rem' }
});